"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M24.025 28.479v-2.694a1.958 1.958 0 0 1 .438-1.2 16.805 16.805 0 0 0 2.98-9.465c0-6.72-3.283-9.89-8.242-9.89s-8.336 3.317-8.336 9.89a16.925 16.925 0 0 0 3.126 9.469 1.948 1.948 0 0 1 .434 1.2v2.683a1.947 1.947 0 0 1-1.67 1.887C2.071 31.494 0 38.7 0 41.6V44h38v-2.4c0-2.782-1.59-10.024-12.319-11.235a1.949 1.949 0 0 1-1.656-1.886z" }),
  React.createElement("path", { d: "M36.559 27.851a1.755 1.755 0 0 1-1.5-1.7v-2.422a1.762 1.762 0 0 1 .394-1.083 15.125 15.125 0 0 0 2.682-8.519c0-6.048-2.954-8.9-7.418-8.9a8.337 8.337 0 0 0-2.289.338c1.729 2.17 2.851 5.273 2.851 9.552a20.732 20.732 0 0 1-3.417 11.32v.369C37.706 28.6 41.816 35.42 42 40h6v-2.4c0-2.5-1.787-8.664-11.441-9.749z" })
);

